import React from 'react';
import { Link } from 'react-router-dom';

// Styles
import styles from "../DashboardFileManagement.module.css"

// Images
import addIconBlue from "./../../../../assets/img/DashboardICons/AddIconBlue.svg";
// import arrowBlue from "./../../../../assets/img/DashboardICons/ArrowLeftBlue.svg";
import editIcon from "./../../../../assets/img/DashboardICons/editIconBlue.svg";

const ConsultantReportsExpertReport = ({ bleachersReport, id }) => {

    return (
        <>
            <div className="py-2">
                <div className="container-fluid" style={{ minHeight: "300px" }}>
                    <div
                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-2 mx-2"
                        dir="rtl"
                    >
                        <div className={`mb-4 w-100`}>
                            <Link to={{
                                pathname: `/add-consultant-reports-expert-report/${id}`,
                                state: id
                            }}>
                                <img className={`px-1`} src={addIconBlue} alt="add-icon-blue" />
                                <button className={`border-0 bg-transparent px-2 ${styles.text_primary}`}> افزودن </button>
                            </Link>
                        </div>

                        <table className="table mt-1" style={{ textAlign: "center" }}>
                            <thead>
                                <tr>
                                    {/* <th scope="col" className={styles.table_head_th}>تعداد</th> */}
                                    <th scope="col" className={`text-right ${styles.table_head_th}`}>عنوان</th>
                                    <th scope="col" className={styles.table_head_th}>تاریخ</th>
                                    <th scope="col" className={styles.table_head_th}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    bleachersReport?.map(data => (
                                        <tr key={data.id}>
                                            {/* <th scope="row" className={styles.table_th} style={{ border: "none" }}> {data.area} </th> */}
                                            <td className={`text-right ${styles.table_th}`} style={{ border: "none" }}>
                                                {data.reportTitle?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                                            </td>
                                            <td className={`d-flex align-items-center justify-content-center ${styles.table_th}`} style={{ border: "none" }}>
                                                {data.sReportDate?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                                                <div className={styles.rounded_green}></div>
                                                {data.reportTime?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                                            </td>
                                            {/* <td className={`${styles.table_th}`} style={{ border: "none" }}>
                                                <Link to={""}>
                                                    <img className={`${styles.consultantIconsTable}`} src={arrowBlue} alt="arrow-left-blue" />
                                                </Link>
                                            </td> */}
                                            <td className={`${styles.table_th}`} style={{ border: "none" }}>
                                                <Link to={{
                                                    pathname: `/consultant-reports-expert-report/${data.id}`,
                                                    state: data
                                                }}>
                                                    <img className={`${styles.consultantIconsTable}`} src={editIcon} alt="edit-icon-blue" />
                                                </Link>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ConsultantReportsExpertReport;